var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLyandforecast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_9299890"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.375 22.8H0.3V22.875V23.625V23.7H0.375H23.625H23.7V23.625V22.875V22.8H23.625H0.375Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.125 22.2H16.2V22.125V15.375C16.2 15.1273 15.9977 14.925 15.75 14.925H13.5C13.2523 14.925 13.05 15.1273 13.05 15.375V22.125V22.2H13.125H13.875H13.95V22.125V15.825H15.3V22.125V22.2H15.375H16.125Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.875 22.2H10.95V22.125V13.125C10.95 12.8773 10.7477 12.675 10.5 12.675H8.25C8.00233 12.675 7.8 12.8773 7.8 13.125V22.125V22.2H7.875H8.625H8.7V22.125V13.575H10.05V22.125V22.2H10.125H10.875Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.45 22.125V17.7H4.8V22.125V22.2H4.875H5.625H5.7V22.125V17.25C5.7 17.0023 5.49767 16.8 5.25 16.8H3C2.75233 16.8 2.55 17.0023 2.55 17.25V22.125V22.2H2.625H3.375H3.45V22.125Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.7531 10.5572C13.9092 10.6018 14.0786 10.5581 14.1918 10.4467L20.4394 5.19873L20.5021 5.14611L20.4442 5.08827L19.9155 4.55952L19.867 4.51101L19.8143 4.555L13.7523 9.62201L8.75429 8.19294L8.75398 8.19285C8.61113 8.15267 8.45325 8.18337 8.33922 8.28366C8.33919 8.28369 8.33916 8.28372 8.33913 8.28375L2.46437 13.4085L2.40879 13.457L2.45633 13.5134L2.94008 14.0871L2.98928 14.1455L3.04676 14.0953L8.73638 9.12542L13.7531 10.5572ZM13.7531 10.5572L13.7737 10.485L13.7531 10.5572L13.7531 10.5572ZM20.3912 5.1413L20.3381 5.19433L20.3335 5.18972L20.3912 5.1413ZM20.3912 5.1413L20.3429 5.08387L20.3379 5.08807L20.3912 5.1413Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M20.625 20.55H20.55V20.625V22.125V22.2H20.625H21.375H21.45V22.125V20.625V20.55H21.375H20.625Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M18.375 20.55H18.3V20.625V22.125V22.2H18.375H19.125H19.2V22.125V20.625V20.55H19.125H18.375Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M18.3 21.625V21.7H18.375H19.125H19.2V21.625V10.575H20.55V21.625V21.7H20.625H21.375H21.45V21.625V10.125C21.45 9.87733 21.2477 9.675 21 9.675H18.75C18.5023 9.675 18.3 9.87733 18.3 10.125V21.625Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLyandforecast);
export default __webpack_public_path__ + "static/media/lyandforecast.b0ae2c1d32be6f492f7ef7396b35adf7.svg";
export { ForwardRef as ReactComponent };